import { assetPrefix } from 'constants/app';
import { featuresType } from './types';

const ASSET_URL = `${assetPrefix}/homepage/proimage/`;

const toolsFeatures: Array<featuresType> = [
  {
    title: 'Financials',
    url: 'financials',
    description: 'Pelajari Data Laporan Keuangan',
    icon: 'landingicon_Financials.svg',
    features: [
      {
        title: 'Berbagai Tampilan Periode',
        description:
          'Pilih periode data keuangan perusahaan yang ingin kamu liat, mulai dari per kuartal (Quarterly), tahunan (Annual), 12 bulan kebelakang (TTM) ataupun Year-To-Date (YTD).',
      },
      {
        title: 'Grafik Tren & Rasio Keuangan',
        description:
          'Lihat tren pendapatan, laba bersih dan akun lainnya berdasarkan data historikal. Juga dilengkapi rasio keuangan untuk memudahkan analisa Anda.',
      },
      {
        title: 'Pertumbuhan Perusahaan',
        description:
          'Cari tau bagaimana pertumbuhan pendapatan atau laba bersih perusahaan sesuai periode yang diinginkan, Quarter-on-Quarter atau Year-on-Year hanya dengan 2 klik.',
      },
      {
        title: 'Marjin Perusahaan',
        description:
          'Pelajari dan bandingkan marjin yang dihasilkan perusahaan antar periode. Apakah itu Gross Profit Margin ataupun Net Profit Margin.',
      },
      {
        title: 'Drag n Drop',
        description:
          'Bandingkan periode yang kamu butuhkan side by side hanya dengan drag and drop, kamu juga bisa atur sendiri susunan periode laporan keuangan sesuai kebutuhan',
      },
      {
        title: 'IDR atau USD',
        description:
          'Beberapa perusahaan menggunakan USD dalam laporannya, dengan financials kamu bisa liat laporannya tetap dalam USD atau dalam IDR, rubah sesuai kebutuhanmu.',
      },
    ],
  },
  {
    title: 'Keystats',
    url: 'keystats',
    description: 'Rasio-rasio Fundamental yang Lengkap',
    icon: 'landingicon_Keystats.svg',
    features: [
      {
        title: 'Valuasi nilai Perusahaan',
        description:
          'Pelajari data valuasi penting emiten seperti PE ratio, Earning Yield, PBV ratio. Semua dari satu tempat.',
      },
      {
        title: 'Level Hutang',
        description:
          'Cari tahu keadaan kesehatan perusahaan dengan melihat level hutang dari rasio-rasio Solvency seperti Current ratio, Debt to Equity ratio, Interest Coverage dan lainnya.',
      },
      {
        title: 'Alokasi Kas',
        description:
          'Ketahui dan pelajari Berasal dari mana dan digunakan untuk apa kas yang dimiliki oleh emiten.',
      },
      {
        title: 'Deviden',
        description:
          'Liat informasi terkait pembagian dividend perusahaan, berapa jumlah dividend per share yang dibagikan, berapa payout ratio dan berapa besar dividend yield.',
      },
    ],
  },
  {
    title: 'Fundachart',
    url: 'fundachart',
    description: 'Bandingkan Data Emiten secara Visual',
    icon: 'landingicon_Fundachart.svg',
    features: [
      {
        title: 'PE Standard Deviation Band',
        description:
          'Salah satu metode yang sering dipakai oleh institusi untuk melakukan valuasi saham untuk mengetahui apakah saham termasuk murah atau mahal berdasarkan historikal PE Ratio-nya.',
      },
      {
        title: 'PE Price Band',
        description:
          'Lihat langsung apakah harga saham saat ini termasuk murah atau mahal. Tentukan dengan mudah titik harga untuk masuk atau keluar dari sebuah saham.',
      },
      {
        title: 'PBV Standard Deviation Band',
        description:
          'Salah satu metode yang juga sering digunakan oleh institusi untuk melakukan valuasi saham berdasarkan historikal Price to Book Value-nya.',
      },
    ],
  },
  {
    title: 'Chartbit',
    url: 'chartbit',
    description: 'Fitur Charting Professional',
    icon: 'landingicon_Chartbit.svg',
    features: [
      {
        title: 'Real-time Price',
        description:
          'Data harga yang sama dengan data harga di bursa saat itu juga.',
      },
      {
        title: 'Intraday Price Interval',
        description:
          'Periode Harga mulai dari 1 menit, 5,menit, 30 menit, sampai 1 jam.',
      },
      {
        title: 'Data historikal hingga 15 tahun',
        description:
          'Lihat trend harga saham sampai dengan 15 tahun kebelakang untuk menganalisa trend jangka panjang.',
      },
      {
        title: '100+ Teknikal Indikator',
        description:
          'Tersedia ratusan indikator siap pakai untuk mempertajam analisa teknikal Anda.',
      },
      {
        title: 'Bandarmologi',
        description:
          'Deteksi dan pelajari gerak bandar, jadilah "teman" bandar untuk membantu kamu mendapatkan keuntungan.',
      },
      {
        title: 'Foreign Flow',
        description:
          'Pantau pergerakan dana asing di saham pilihanmu, apakah net inflow atau outflow. Pelajari juga seberapa kuat transaksi dana asing pada saham tersebut.',
      },
      {
        title: 'Corporate Action Event',
        description:
          'Lihat langsung aksi korporasi dan pengaruhnya terhadap pergerakan harga sahamnya.',
      },
    ],
  },
  {
    title: 'Screener',
    url: 'screener',
    description: 'Cari Saham sesuai Kriteria Kamu',
    icon: 'landingicon_Screener.svg',
    features: [
      {
        title: 'Guru Screener',
        description:
          'Cari saham yang memenuhi kriteria "guru" investasi dunia seperti Warren Buffett, Peter Lynch, Piotroski dan lainnya.',
      },
      {
        title: 'Preset Screener',
        description:
          'Screener Siap pakai untuk mencari saham dengan kriteria yang biasa digunakan oleh investor profesional.',
      },
      {
        title: '100+ Rasio-rasio keuangan',
        description:
          'Data keuangan dan rasio keuangan yang lengkap sehingga kamu bisa menentukan sendiri kriteria saham yang kamu inginkan.',
      },
      {
        title: 'Ratio Vs Ratio',
        description:
          'Gunakan perbandingan dua rasio berbeda sebagai kriteria dari screener buatanmu.',
      },
    ],
  },
  {
    title: 'Price Alert',
    url: 'price-alert',
    description: 'Notifikasi Real-Time Saat Harga Kamu Tercapai',
    icon: 'landingicon_Price-Alert.svg',
    features: [
      {
        title: 'Push Notification',
        description:
          'Dapatkan notifikasi langsung di smartphone-mu saat harga saham mencapai harga yang telah kamu tentukan.',
      },
      {
        title: 'Real-Time Alert',
        description:
          'Notifikasi yang dikirimkan berdasarkan harga di bursa, sehingga kamu tidak akan ketinggalan momentum.',
      },
    ],
  },
  {
    title: 'Seasonality',
    url: 'seasonality',
    description: 'Lihat Pergerakan Saham Pada Bulan-bulan Tertentu',
    icon: 'landingicon_Seasonality.svg',
    features: [
      {
        title: 'Lebih dari 15 Tahun Price History',
        description:
          'Lihat kebiasaan pergerakan harga setiap bulan, hingga lebih dari 15 tahun kebelakang untuk mengetahui pada bulan apa biasanya harga cenderung naik atau turun.',
      },
      {
        title: 'Probabilitas Kenaikan',
        description:
          'Probabilitas kenaikan untuk setiap bulannya akan otomatis terhitung. Hint: $IHSG 100% positif pada bulan Desember selama 16 tahun terakhir.',
      },
    ],
  },
  {
    title: 'Earnings',
    url: 'earnings',
    description: 'Rangkuman Laba Bersih Perusahaan Setiap Periode',
    icon: 'landingicon_Earnings.svg',
    features: [
      {
        title: 'Tepat Waktu',
        description:
          'Lihat rekap laba bersih emiten pilihanmu langsung ketika emiten mengeluarkan laporan keuangan.',
      },
      {
        title: 'Bandingkan dengan Estimasi Analis',
        description:
          'Bandingkan laba bersih yang dilaporkan perusahaan dengan estimasi para analis. Apakah di atas estimasi atau di bawah estimasi?',
      },
      {
        title: 'Bandingkan dengan Tahun Lalu',
        description:
          'Bandingkan hasil laba bersih pada kuartal saat ini dengan kuartal yang sama pada tahun sebelumnya.',
      },
    ],
  },
  {
    title: 'Comparison',
    url: 'comparison',
    description: 'Bandingkan Data Emiten Satu dengan Lainnya',
    icon: 'landingicon_Comparison.svg',
    features: [
      {
        title: 'Pembanding yang Sesuai',
        description:
          'Sistem kami secara otomatis akan membantu membandingkan emiten pilihan Anda dengan emiten sejenisnya sehingga tidak perlu lagi repot dan bingung mencari perbandingan emiten yang sesuai.',
      },
      {
        title: 'Komparasi Secara Rinci',
        description:
          'Dilengkapi dengan puluhan rasio dan financial metrics, laukan komparasi emiten dari berbagai aspek secara rinci dan mudah. Ditambah adanya angka rata-rata untuk masing-masing industri dan sektor emiten terkait sebagai pembanding untuk membantu memilih emiten yang paling sesuai dengan kriteria.',
      },
    ],
  },
];

export { ASSET_URL, toolsFeatures };
